import { excludeProps, mixins, styled } from '@bob/library'
import { GatsbyLinkProps, Link } from 'gatsby'
import { FC } from 'react'
import type { StyledComponent } from 'styled-components'

export type SpotLinkTypes = 'primary' | 'secondary' | 'tertiary'
export type SpotLinkVariants = 'blue' | 'white' | 'black' | 'green'

export type SpotLinkProps = {
  ctaType: SpotLinkTypes
  ctaVariant: SpotLinkVariants
  noStyles?: boolean
  isEmpty?: boolean
}

export const StyledButton: StyledComponent<
  'button',
  any,
  SpotLinkProps,
  never
> = styled.button<SpotLinkProps>`
  ${(p: SpotLinkProps) => (p.noStyles ? '' : mixins.cta[p.ctaType](p.ctaVariant))}
  cursor: ${(p: SpotLinkProps) => (p.isEmpty ? 'unset' : 'pointer')};
`

export const StyledAnchor: StyledComponent<
  'a',
  any,
  SpotLinkProps,
  never
> = styled.a<SpotLinkProps>`
  max-width: 100%;
  ${(p: SpotLinkProps) => (p.noStyles ? '' : mixins.cta[p.ctaType](p.ctaVariant))}
  cursor: ${(p: SpotLinkProps) => (p.isEmpty ? 'unset' : 'pointer')};
`

export const StyledLink: StyledComponent<any, any, SpotLinkProps, never> = styled(
  // Needed to cast as FC for now. Not sure how to get around.
  excludeProps(
    Link as unknown as FC<GatsbyLinkProps<any>>,
    'ctaType',
    'ctaVariant',
    'noStyles',
    'isEmpty'
  )
)<SpotLinkProps>`
  ${(p: SpotLinkProps) => (p.noStyles ? '' : mixins.cta[p.ctaType](p.ctaVariant))}
  cursor: ${(p: SpotLinkProps) => (p.isEmpty ? 'unset' : 'pointer')};
`
